export default "<div class=\"dispatch-transporteur\">\n  {{DispatchTransporteurInComponent}}\n</div>\n\n";